import { createAction, props } from '@ngrx/store';

import { FollowupActions } from '~/repositories/followup/store/followup.const';
import { FollowUpTask, TaskStatus } from '~/repositories/followup/store/followup.models';

export const fetchFollowupsForDecree = createAction(
  FollowupActions.fetchFollowupsForDecree,
  props<{
    decreeId: string;
  }>()
);
export const fetchFollowupsForDecreeSuccess = createAction(
  FollowupActions.fetchFollowupsForDecreeSuccess,
  props<{ followupTasks: FollowUpTask[] }>()
);
export const fetchFollowupsForDecreeFailure = createAction(
  FollowupActions.fetchFollowupsForDecreeFailure,
  props<{
    error: any;
  }>()
);

export const publishFollowup = createAction(
  FollowupActions.publishFollowup,
  props<{
    followup: FollowUpTask;
    objectMetaId: string;
  }>()
);
export const publishFollowupSuccess = createAction(
  FollowupActions.publishFollowupSuccess,
  props<{
    followup: FollowUpTask;
  }>()
);
export const publishFollowupFailure = createAction(FollowupActions.publishFollowupFailure, props<{ error: any }>());

export const removeFollowupTask = createAction(FollowupActions.removeFollowupTask, props<{ taskId: string }>());
export const removeFollowupTaskSuccess = createAction(
  FollowupActions.removeFollowupTaskSuccess,
  props<{
    taskId: string;
  }>()
);
export const removeFollowupTaskFailed = createAction(
  FollowupActions.removeFollowupTaskFailed,
  props<{
    error: any;
  }>()
);

export const updateStatus = createAction(
  FollowupActions.updateStatus,
  props<{
    taskIds: string[];
    status: TaskStatus;
    additionalInfo: string;
  }>()
);

export const updateStatusSuccess = createAction(
  FollowupActions.updateStatusSuccess,
  props<{
    followupTasks: FollowUpTask[];
  }>()
);
export const updateStatusFailed = createAction(
  FollowupActions.updateStatusFailed,
  props<{
    error: any;
  }>()
);

export const updateFollowupTask = createAction(
  FollowupActions.updateFollowupTask,
  props<{
    taskId: string;
    followupTask: FollowUpTask;
  }>()
);
export const updateFollowupTaskSuccess = createAction(
  FollowupActions.updateFollowupTaskSuccess,
  props<{
    followupTask: FollowUpTask;
  }>()
);
export const updateFollowupTaskFailed = createAction(
  FollowupActions.updateFollowupTaskFailed,
  props<{
    error: any;
  }>()
);

export const assignTasks = createAction(
  FollowupActions.assignTasks,
  props<{
    taskIds: string[];
    assignedUserId: string;
  }>()
);
export const assignTasksSuccess = createAction(
  FollowupActions.assignTasksSuccess,
  props<{
    followupTasks: FollowUpTask[];
  }>()
);
export const assignTasksFailed = createAction(FollowupActions.assignTasksFailed, props<{ error: any }>());
